import { render, staticRenderFns } from "./PosReport.vue?vue&type=template&id=24183d47&"
import script from "./PosReport.vue?vue&type=script&lang=js&"
export * from "./PosReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports